import { forgotPassword } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query';

const useRequestReset = () => {
    const { mutate: forgotMutation } = useMutation({
        mutationKey: 'forgotPassword',
        mutationFn: (model) => forgotPassword(model),
        onSuccess: (data) => {
            notifications.show({
                title: 'Success',
                message: 'Check your email for instructions',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return forgotMutation;
};
export default useRequestReset;
